import React from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { TextInput } from '@uplift/ui-v2';
import { useL10n } from '@uplift/hooks';
import { FormFooter } from '../components/FormFooter';
import { RematchingContainer } from '../components/RematchingContainer';


const useValidationSchema = () => {
  const l10n = useL10n();

  return React.useMemo(() => (
    Yup.object().shape({
      details: Yup.string().required(l10n.validations.required),
    })
  ), [ l10n ]);
};


export const RematchingMoreDetailsPage: React.VFC<{
  back?: () => void;
  next?: (details: string) => void;
  details?: string;
}> = ({ next, back, details }) => {
  const { classes } = useMoreDetailsPageStyles();
  const validationSchema = useValidationSchema();

  return (
    <RematchingContainer>
      <Typography variant="h3">Can you provide more detail about what’s happening?</Typography>
      <Typography className={classes.description}>We’re sorry to hear you’re not happy with your care and we want to look into the issues you’re experiencing. The more details we have, the better.</Typography>
      <Formik
        initialValues={{
          details: details || '',
        }}
        validateOnMount
        validationSchema={validationSchema}
        onSubmit={v => {
          next(v.details);
        }}
      >
        {(formik) => (
          <>
            <Box mt={4} mb={6}>
              <TextInput
                autoFocus
                fullWidth
                multiline
                name="details"
                rows={8}
              />
            </Box>
            <FormFooter
              nextDisabled={!formik.isValid}
              onBack={back}
              onNext={formik.handleSubmit}
            />
          </>
        )}
      </Formik>
    </RematchingContainer>
  );
};

const useMoreDetailsPageStyles = makeStyles({ name: 'MoreDetailsPage' })(theme => ({
  description: {
    marginTop: theme.spacing(1),
  },
}));
